import qs from 'qs';
import snakeCaseKeys from 'snakecase-keys';
import camelcaseKeys from 'camelcase-keys';
import history from './history';
import { setAuthorization } from './auth';

const UNAUTHORIZED = 401;
const INTERNAL_SERVER_ERROR = 500;

export const setData = (config) => {
  const newConfig = { ...config };
  newConfig.url = `${config.url}`;

  if (newConfig.headers['Content-Type'] === 'multipart/form-data')
    return newConfig;
  if (config.params) {
    newConfig.params = snakeCaseKeys(config.params);
  }
  if (config.data) {
    newConfig.data = snakeCaseKeys(config.data);
  }

  newConfig.paramsSerializer = (p) =>
    qs.stringify(p, {
      skipNulls: true,
      arrayFormat: 'repeat',
    });

  return newConfig;
};

export const setAxiosRequestConfig = async (config) => {
  let newConfig = { ...config };
  newConfig = await setAuthorization(config);

  newConfig = await setData(config);

  return newConfig;
};

export const errorHandler = (error, redirect) => {
  const { status } = error.response;
  if (status === UNAUTHORIZED) {
    history.push('/novo/unauthorized');
  }
  if (status === INTERNAL_SERVER_ERROR) {
    history.push(`/novo/error?redirect=${redirect}`);
  }
  return Promise.reject(error);
};

export const setAxiosResponseConfig = async (response) => {
  if (response.status === UNAUTHORIZED) {
    history.push('/novo/Login');
  }
  return camelcaseKeys(response, { deep: true });
};
